// Generated by Melange

import * as Buhta_taxapis__Buhta_tax_control_v1_period from "./buhta_tax_control_v1_period.js";
import * as Buhta_taxapis__Buhta_tax_control_v1_person_category from "./buhta_tax_control_v1_person_category.js";
import * as Buhta_taxapis__Buhta_tax_control_v1_person_status from "./buhta_tax_control_v1_person_status.js";
import * as Buhta_taxapis__Buhta_tax_control_v1_tax_category from "./buhta_tax_control_v1_tax_category.js";
import * as Buhta_taxapis__Buhta_tax_control_v1_tax_deduction_type from "./buhta_tax_control_v1_tax_deduction_type.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Google_wkt__Google_protobuf_struct from "../../third_party/google_wkt/gen/google_protobuf_struct.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const CalculatePayrollRequest = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  953,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CalculatePayrollResponse = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  1083,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Employee"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PersonInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const Earning = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  1335,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PayrollTax"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.tax.payment.v1alpha1.CalculatePayrollRequest";
}

function make(period, report_blanksOpt, param) {
  const report_blanks = report_blanksOpt !== undefined ? report_blanksOpt : false;
  return {
    period: period,
    report_blanks: report_blanks
  };
}

const $$let = Buhta_taxapis__Buhta_tax_control_v1_period.Buhta.Tax.Control.V1.Period;

const merge_period = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "period",
    "period"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

const merge_report_blanks = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "report_blanks",
    "reportBlanks"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge(t1, t2) {
  return {
    period: Curry._2(merge_period, t1.period, t2.period),
    report_blanks: Curry._2(merge_report_blanks, t1.report_blanks, t2.report_blanks)
  };
}

function spec(param) {
  const $$let = Buhta_taxapis__Buhta_tax_control_v1_period.Buhta.Tax.Control.V1.Period;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "period",
      "period"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "report_blanks",
      "reportBlanks"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.period, param.report_blanks);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(period, report_blanks) {
  return {
    period: period,
    report_blanks: report_blanks
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.CalculatePayrollRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.period, param.report_blanks);
  };
}

function constructor$1(period, report_blanks) {
  return {
    period: period,
    report_blanks: report_blanks
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.CalculatePayrollRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CalculatePayrollRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

const Employee = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  1115,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const PersonInfo = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  1183,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$1(param) {
  return ".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.Employee";
}

function make$1(info, earningsOpt, param) {
  const earnings = earningsOpt !== undefined ? earningsOpt : /* [] */ 0;
  return {
    info: info,
    earnings: earnings
  };
}

const merge_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "info",
    "info"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: PersonInfo.name,
    make: PersonInfo.make,
    from_proto: PersonInfo.from_proto,
    from_proto_exn: PersonInfo.from_proto_exn,
    to_proto: PersonInfo.to_proto,
    to_proto$p: PersonInfo.to_proto$p,
    merge: PersonInfo.merge,
    to_json: PersonInfo.to_json,
    from_json_exn: PersonInfo.from_json_exn,
    from_json: PersonInfo.from_json
  })
]));

const merge_earnings = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    3,
    "earnings",
    "earnings"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Earning.name,
    make: Earning.make,
    from_proto: Earning.from_proto,
    from_proto_exn: Earning.from_proto_exn,
    to_proto: Earning.to_proto,
    to_proto$p: Earning.to_proto$p,
    merge: Earning.merge,
    to_json: Earning.to_json,
    from_json_exn: Earning.from_json_exn,
    from_json: Earning.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$1(t1, t2) {
  return {
    info: Curry._2(merge_info, t1.info, t2.info),
    earnings: Curry._2(merge_earnings, t1.earnings, t2.earnings)
  };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "info",
      "info"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: PersonInfo.name,
      make: PersonInfo.make,
      from_proto: PersonInfo.from_proto,
      from_proto_exn: PersonInfo.from_proto_exn,
      to_proto: PersonInfo.to_proto,
      to_proto$p: PersonInfo.to_proto$p,
      merge: PersonInfo.merge,
      to_json: PersonInfo.to_json,
      from_json_exn: PersonInfo.from_json_exn,
      from_json: PersonInfo.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      3,
      "earnings",
      "earnings"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Earning.name,
      make: Earning.make,
      from_proto: Earning.from_proto,
      from_proto_exn: Earning.from_proto_exn,
      to_proto: Earning.to_proto,
      to_proto$p: Earning.to_proto$p,
      merge: Earning.merge,
      to_json: Earning.to_json,
      from_json_exn: Earning.from_json_exn,
      from_json: Earning.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._3(serialize$1, writer, param.info, param.earnings);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(info, earnings) {
  return {
    info: info,
    earnings: earnings
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.Employee", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.info, param.earnings);
  };
}

function constructor$3(info, earnings) {
  return {
    info: info,
    earnings: earnings
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.Employee", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Employee, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.PersonInfo";
}

function make$2(employee_id, tinOpt, family_nameOpt, given_nameOpt, patronymic_name, birthday_date, param) {
  const tin = tinOpt !== undefined ? tinOpt : "";
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  return {
    employee_id: employee_id,
    tin: tin,
    family_name: family_name,
    given_name: given_name,
    patronymic_name: patronymic_name,
    birthday_date: birthday_date
  };
}

const merge_employee_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "employee_id",
    "employeeId"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "family_name",
    "familyName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "given_name",
    "givenName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    5,
    "patronymic_name",
    "patronymicName"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_birthday_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "birthday_date",
    "birthdayDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    employee_id: Curry._2(merge_employee_id, t1.employee_id, t2.employee_id),
    tin: Curry._2(merge_tin, t1.tin, t2.tin),
    family_name: Curry._2(merge_family_name, t1.family_name, t2.family_name),
    given_name: Curry._2(merge_given_name, t1.given_name, t2.given_name),
    patronymic_name: Curry._2(merge_patronymic_name, t1.patronymic_name, t2.patronymic_name),
    birthday_date: Curry._2(merge_birthday_date, t1.birthday_date, t2.birthday_date)
  };
}

function spec$2(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "employee_id",
      "employeeId"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "family_name",
      "familyName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "given_name",
      "givenName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      5,
      "patronymic_name",
      "patronymicName"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "birthday_date",
      "birthdayDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil))))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._7(serialize$2, writer, param.employee_id, param.tin, param.family_name, param.given_name, param.patronymic_name, param.birthday_date);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(employee_id, tin, family_name, given_name, patronymic_name, birthday_date) {
  return {
    employee_id: employee_id,
    tin: tin,
    family_name: family_name,
    given_name: given_name,
    patronymic_name: patronymic_name,
    birthday_date: birthday_date
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.PersonInfo", spec$2(undefined))(options);
  return function (param) {
    return Curry._6(serialize, param.employee_id, param.tin, param.family_name, param.given_name, param.patronymic_name, param.birthday_date);
  };
}

function constructor$5(employee_id, tin, family_name, given_name, patronymic_name, birthday_date) {
  return {
    employee_id: employee_id,
    tin: tin,
    family_name: family_name,
    given_name: given_name,
    patronymic_name: patronymic_name,
    birthday_date: birthday_date
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse.PersonInfo", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PersonInfo, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.tax.payment.v1alpha1.CalculatePayrollResponse";
}

function make$3(chief, employeesOpt, param) {
  const employees = employeesOpt !== undefined ? employeesOpt : /* [] */ 0;
  return {
    chief: chief,
    employees: employees
  };
}

const merge_chief = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "chief",
    "chief"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Employee.name,
    make: Employee.make,
    from_proto: Employee.from_proto,
    from_proto_exn: Employee.from_proto_exn,
    to_proto: Employee.to_proto,
    to_proto$p: Employee.to_proto$p,
    merge: Employee.merge,
    to_json: Employee.to_json,
    from_json_exn: Employee.from_json_exn,
    from_json: Employee.from_json
  })
]));

const merge_employees = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    2,
    "employees",
    "employees"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: Employee.name,
    make: Employee.make,
    from_proto: Employee.from_proto,
    from_proto_exn: Employee.from_proto_exn,
    to_proto: Employee.to_proto,
    to_proto$p: Employee.to_proto$p,
    merge: Employee.merge,
    to_json: Employee.to_json,
    from_json_exn: Employee.from_json_exn,
    from_json: Employee.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$3(t1, t2) {
  return {
    chief: Curry._2(merge_chief, t1.chief, t2.chief),
    employees: Curry._2(merge_employees, t1.employees, t2.employees)
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "chief",
      "chief"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Employee.name,
      make: Employee.make,
      from_proto: Employee.from_proto,
      from_proto_exn: Employee.from_proto_exn,
      to_proto: Employee.to_proto,
      to_proto$p: Employee.to_proto$p,
      merge: Employee.merge,
      to_json: Employee.to_json,
      from_json_exn: Employee.from_json_exn,
      from_json: Employee.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      2,
      "employees",
      "employees"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: Employee.name,
      make: Employee.make,
      from_proto: Employee.from_proto,
      from_proto_exn: Employee.from_proto_exn,
      to_proto: Employee.to_proto,
      to_proto$p: Employee.to_proto$p,
      merge: Employee.merge,
      to_json: Employee.to_json,
      from_json_exn: Employee.from_json_exn,
      from_json: Employee.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.chief, param.employees);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(chief, employees) {
  return {
    chief: chief,
    employees: employees
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.chief, param.employees);
  };
}

function constructor$7(chief, employees) {
  return {
    chief: chief,
    employees: employees
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.CalculatePayrollResponse", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Employee"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PersonInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CalculatePayrollResponse, {
  Employee: Employee,
  PersonInfo: PersonInfo,
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

const PayrollTax = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_payment_v1alpha1_payroll_tax_service.ml",
  1371,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$4(param) {
  return ".buhta.tax.payment.v1alpha1.Earning.PayrollTax";
}

function make$4(tax_categoryOpt, amount, exemptOpt, exempt_reasonOpt, descriptionOpt, metadata, param) {
  const tax_category = tax_categoryOpt !== undefined ? tax_categoryOpt : Curry._1(Buhta_taxapis__Buhta_tax_control_v1_tax_category.Buhta.Tax.Control.V1.TaxCategory.from_int_exn, 0);
  const exempt = exemptOpt !== undefined ? exemptOpt : false;
  const exempt_reason = exempt_reasonOpt !== undefined ? exempt_reasonOpt : "";
  const description = descriptionOpt !== undefined ? descriptionOpt : "";
  return {
    tax_category: tax_category,
    amount: amount,
    exempt: exempt,
    exempt_reason: exempt_reason,
    description: description,
    metadata: metadata
  };
}

const merge_tax_category = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "tax_category",
    "taxCategory"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_tax_category.Buhta.Tax.Control.V1.TaxCategory),
  Curry._1(Buhta_taxapis__Buhta_tax_control_v1_tax_category.Buhta.Tax.Control.V1.TaxCategory.from_int_exn, 0)
]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "amount",
    "amount"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_exempt = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "exempt",
    "exempt"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_exempt_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "exempt_reason",
    "exemptReason"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_description = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "description",
    "description"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let$2 = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;

const merge_metadata = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "metadata",
    "metadata"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  })
]));

function merge$4(t1, t2) {
  return {
    tax_category: Curry._2(merge_tax_category, t1.tax_category, t2.tax_category),
    amount: Curry._2(merge_amount, t1.amount, t2.amount),
    exempt: Curry._2(merge_exempt, t1.exempt, t2.exempt),
    exempt_reason: Curry._2(merge_exempt_reason, t1.exempt_reason, t2.exempt_reason),
    description: Curry._2(merge_description, t1.description, t2.description),
    metadata: Curry._2(merge_metadata, t1.metadata, t2.metadata)
  };
}

function spec$4(param) {
  const $$let = Google_wkt__Google_protobuf_struct.Google.Protobuf.Struct;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "tax_category",
      "taxCategory"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_tax_category.Buhta.Tax.Control.V1.TaxCategory),
    Curry._1(Buhta_taxapis__Buhta_tax_control_v1_tax_category.Buhta.Tax.Control.V1.TaxCategory.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "amount",
      "amount"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "exempt",
      "exempt"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "exempt_reason",
      "exemptReason"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "description",
      "description"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "metadata",
      "metadata"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil))))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._7(serialize$4, writer, param.tax_category, param.amount, param.exempt, param.exempt_reason, param.description, param.metadata);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(tax_category, amount, exempt, exempt_reason, description, metadata) {
  return {
    tax_category: tax_category,
    amount: amount,
    exempt: exempt,
    exempt_reason: exempt_reason,
    description: description,
    metadata: metadata
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.Earning.PayrollTax", spec$4(undefined))(options);
  return function (param) {
    return Curry._6(serialize, param.tax_category, param.amount, param.exempt, param.exempt_reason, param.description, param.metadata);
  };
}

function constructor$9(tax_category, amount, exempt, exempt_reason, description, metadata) {
  return {
    tax_category: tax_category,
    amount: amount,
    exempt: exempt,
    exempt_reason: exempt_reason,
    description: description,
    metadata: metadata
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.Earning.PayrollTax", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, PayrollTax, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.tax.payment.v1alpha1.Earning";
}

function make$5(monthOpt, residentOpt, eaeu_residentOpt, has_residence_permitOpt, statusOpt, categoriesOpt, tax_deduction_typesOpt, net_incomeOpt, gross_incomeOpt, payroll_deductionsOpt, payroll_taxesOpt, param) {
  const month = monthOpt !== undefined ? monthOpt : 0;
  const resident = residentOpt !== undefined ? residentOpt : false;
  const eaeu_resident = eaeu_residentOpt !== undefined ? eaeu_residentOpt : false;
  const has_residence_permit = has_residence_permitOpt !== undefined ? has_residence_permitOpt : false;
  const status = statusOpt !== undefined ? statusOpt : Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_status.Buhta.Tax.Control.V1.PersonStatus.from_int_exn, 0);
  const categories = categoriesOpt !== undefined ? categoriesOpt : /* [] */ 0;
  const tax_deduction_types = tax_deduction_typesOpt !== undefined ? tax_deduction_typesOpt : /* [] */ 0;
  const net_income = net_incomeOpt !== undefined ? net_incomeOpt : "";
  const gross_income = gross_incomeOpt !== undefined ? gross_incomeOpt : "";
  const payroll_deductions = payroll_deductionsOpt !== undefined ? payroll_deductionsOpt : /* [] */ 0;
  const payroll_taxes = payroll_taxesOpt !== undefined ? payroll_taxesOpt : /* [] */ 0;
  return {
    month: month,
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    status: status,
    categories: categories,
    tax_deduction_types: tax_deduction_types,
    net_income: net_income,
    gross_income: gross_income,
    payroll_deductions: payroll_deductions,
    payroll_taxes: payroll_taxes
  };
}

const merge_month = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "month",
    "month"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "resident",
    "resident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_eaeu_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "eaeu_resident",
    "eaeuResident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_has_residence_permit = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "has_residence_permit",
    "hasResidencePermit"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_status = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    9,
    "status",
    "status"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_status.Buhta.Tax.Control.V1.PersonStatus),
  Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_status.Buhta.Tax.Control.V1.PersonStatus.from_int_exn, 0)
]));

const merge_categories = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    10,
    "categories",
    "categories"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory),
  Ocaml_protoc_plugin__Spec.packed
]));

const merge_tax_deduction_types = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    11,
    "tax_deduction_types",
    "taxDeductionTypes"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_tax_deduction_type.Buhta.Tax.Control.V1.TaxDeductionType),
  Ocaml_protoc_plugin__Spec.packed
]));

const merge_net_income = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    15,
    "net_income",
    "netIncome"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_gross_income = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    16,
    "gross_income",
    "grossIncome"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_payroll_deductions = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    17,
    "payroll_deductions",
    "payrollDeductions"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: PayrollTax.name,
    make: PayrollTax.make,
    from_proto: PayrollTax.from_proto,
    from_proto_exn: PayrollTax.from_proto_exn,
    to_proto: PayrollTax.to_proto,
    to_proto$p: PayrollTax.to_proto$p,
    merge: PayrollTax.merge,
    to_json: PayrollTax.to_json,
    from_json_exn: PayrollTax.from_json_exn,
    from_json: PayrollTax.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

const merge_payroll_taxes = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    18,
    "payroll_taxes",
    "payrollTaxes"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: PayrollTax.name,
    make: PayrollTax.make,
    from_proto: PayrollTax.from_proto,
    from_proto_exn: PayrollTax.from_proto_exn,
    to_proto: PayrollTax.to_proto,
    to_proto$p: PayrollTax.to_proto$p,
    merge: PayrollTax.merge,
    to_json: PayrollTax.to_json,
    from_json_exn: PayrollTax.from_json_exn,
    from_json: PayrollTax.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$5(t1, t2) {
  return {
    month: Curry._2(merge_month, t1.month, t2.month),
    resident: Curry._2(merge_resident, t1.resident, t2.resident),
    eaeu_resident: Curry._2(merge_eaeu_resident, t1.eaeu_resident, t2.eaeu_resident),
    has_residence_permit: Curry._2(merge_has_residence_permit, t1.has_residence_permit, t2.has_residence_permit),
    status: Curry._2(merge_status, t1.status, t2.status),
    categories: Curry._2(merge_categories, t1.categories, t2.categories),
    tax_deduction_types: Curry._2(merge_tax_deduction_types, t1.tax_deduction_types, t2.tax_deduction_types),
    net_income: Curry._2(merge_net_income, t1.net_income, t2.net_income),
    gross_income: Curry._2(merge_gross_income, t1.gross_income, t2.gross_income),
    payroll_deductions: Curry._2(merge_payroll_deductions, t1.payroll_deductions, t2.payroll_deductions),
    payroll_taxes: Curry._2(merge_payroll_taxes, t1.payroll_taxes, t2.payroll_taxes)
  };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "month",
      "month"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "resident",
      "resident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "eaeu_resident",
      "eaeuResident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "has_residence_permit",
      "hasResidencePermit"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      9,
      "status",
      "status"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_status.Buhta.Tax.Control.V1.PersonStatus),
    Curry._1(Buhta_taxapis__Buhta_tax_control_v1_person_status.Buhta.Tax.Control.V1.PersonStatus.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      10,
      "categories",
      "categories"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_person_category.Buhta.Tax.Control.V1.PersonCategory),
    Ocaml_protoc_plugin__Spec.packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      11,
      "tax_deduction_types",
      "taxDeductionTypes"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_taxapis__Buhta_tax_control_v1_tax_deduction_type.Buhta.Tax.Control.V1.TaxDeductionType),
    Ocaml_protoc_plugin__Spec.packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      15,
      "net_income",
      "netIncome"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      16,
      "gross_income",
      "grossIncome"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      17,
      "payroll_deductions",
      "payrollDeductions"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: PayrollTax.name,
      make: PayrollTax.make,
      from_proto: PayrollTax.from_proto,
      from_proto_exn: PayrollTax.from_proto_exn,
      to_proto: PayrollTax.to_proto,
      to_proto$p: PayrollTax.to_proto$p,
      merge: PayrollTax.merge,
      to_json: PayrollTax.to_json,
      from_json_exn: PayrollTax.from_json_exn,
      from_json: PayrollTax.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      18,
      "payroll_taxes",
      "payrollTaxes"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: PayrollTax.name,
      make: PayrollTax.make,
      from_proto: PayrollTax.from_proto,
      from_proto_exn: PayrollTax.from_proto_exn,
      to_proto: PayrollTax.to_proto,
      to_proto$p: PayrollTax.to_proto$p,
      merge: PayrollTax.merge,
      to_json: PayrollTax.to_json,
      from_json_exn: PayrollTax.from_json_exn,
      from_json: PayrollTax.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil)))))))))));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry.app(serialize$5, [
    writer,
    param.month,
    param.resident,
    param.eaeu_resident,
    param.has_residence_permit,
    param.status,
    param.categories,
    param.tax_deduction_types,
    param.net_income,
    param.gross_income,
    param.payroll_deductions,
    param.payroll_taxes
  ]);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(month, resident, eaeu_resident, has_residence_permit, status, categories, tax_deduction_types, net_income, gross_income, payroll_deductions, payroll_taxes) {
  return {
    month: month,
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    status: status,
    categories: categories,
    tax_deduction_types: tax_deduction_types,
    net_income: net_income,
    gross_income: gross_income,
    payroll_deductions: payroll_deductions,
    payroll_taxes: payroll_taxes
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.payment.v1alpha1.Earning", spec$5(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.month,
      param.resident,
      param.eaeu_resident,
      param.has_residence_permit,
      param.status,
      param.categories,
      param.tax_deduction_types,
      param.net_income,
      param.gross_income,
      param.payroll_deductions,
      param.payroll_taxes
    ]);
  };
}

function constructor$11(month, resident, eaeu_resident, has_residence_permit, status, categories, tax_deduction_types, net_income, gross_income, payroll_deductions, payroll_taxes) {
  return {
    month: month,
    resident: resident,
    eaeu_resident: eaeu_resident,
    has_residence_permit: has_residence_permit,
    status: status,
    categories: categories,
    tax_deduction_types: tax_deduction_types,
    net_income: net_income,
    gross_income: gross_income,
    payroll_deductions: payroll_deductions,
    payroll_taxes: payroll_taxes
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.payment.v1alpha1.Earning", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "PayrollTax"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Earning, {
  PayrollTax: PayrollTax,
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

const calculatePayroll_0 = {
  name: CalculatePayrollRequest.name,
  make: CalculatePayrollRequest.make,
  from_proto: CalculatePayrollRequest.from_proto,
  from_proto_exn: CalculatePayrollRequest.from_proto_exn,
  to_proto: CalculatePayrollRequest.to_proto,
  to_proto$p: CalculatePayrollRequest.to_proto$p,
  merge: CalculatePayrollRequest.merge,
  to_json: CalculatePayrollRequest.to_json,
  from_json_exn: CalculatePayrollRequest.from_json_exn,
  from_json: CalculatePayrollRequest.from_json
};

const calculatePayroll_1 = {
  name: CalculatePayrollResponse.name,
  make: CalculatePayrollResponse.make,
  from_proto: CalculatePayrollResponse.from_proto,
  from_proto_exn: CalculatePayrollResponse.from_proto_exn,
  to_proto: CalculatePayrollResponse.to_proto,
  to_proto$p: CalculatePayrollResponse.to_proto$p,
  merge: CalculatePayrollResponse.merge,
  to_json: CalculatePayrollResponse.to_json,
  from_json_exn: CalculatePayrollResponse.from_json_exn,
  from_json: CalculatePayrollResponse.from_json
};

const calculatePayroll = [
  calculatePayroll_0,
  calculatePayroll_1
];

const V1alpha1_PayrollTaxService = {
  CalculatePayroll: {
    name: "/buhta.tax.payment.v1alpha1.PayrollTaxService/CalculatePayroll",
    package_name: "buhta.tax.payment.v1alpha1",
    service_name: "PayrollTaxService",
    method_name: "CalculatePayroll",
    $$Request: {
      name: CalculatePayrollRequest.name,
      make: CalculatePayrollRequest.make,
      from_proto: CalculatePayrollRequest.from_proto,
      from_proto_exn: CalculatePayrollRequest.from_proto_exn,
      to_proto: CalculatePayrollRequest.to_proto,
      to_proto$p: CalculatePayrollRequest.to_proto$p,
      merge: CalculatePayrollRequest.merge,
      to_json: CalculatePayrollRequest.to_json,
      from_json_exn: CalculatePayrollRequest.from_json_exn,
      from_json: CalculatePayrollRequest.from_json
    },
    $$Response: {
      name: CalculatePayrollResponse.name,
      make: CalculatePayrollResponse.make,
      from_proto: CalculatePayrollResponse.from_proto,
      from_proto_exn: CalculatePayrollResponse.from_proto_exn,
      to_proto: CalculatePayrollResponse.to_proto,
      to_proto$p: CalculatePayrollResponse.to_proto$p,
      merge: CalculatePayrollResponse.merge,
      to_json: CalculatePayrollResponse.to_json,
      from_json_exn: CalculatePayrollResponse.from_json_exn,
      from_json: CalculatePayrollResponse.from_json
    }
  },
  calculatePayroll: calculatePayroll
};

const V1alpha1 = {
  CalculatePayrollRequest: CalculatePayrollRequest,
  CalculatePayrollResponse: CalculatePayrollResponse,
  Earning: Earning,
  PayrollTaxService: V1alpha1_PayrollTaxService
};

const Payment = {
  V1alpha1: V1alpha1
};

const Tax = {
  Payment: Payment
};

const Buhta = {
  Tax: Tax
};

export {
  Imported$pmodules,
  Buhta,
}
/* CalculatePayrollRequest Not a pure module */
